import { render } from "./index.vue?vue&type=template&id=245b6ace"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/user-invitation-radio/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "245b6ace"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('245b6ace', __exports__)) {
    api.reload('245b6ace', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=245b6ace", () => {
    api.rerender('245b6ace', render)
  })

}


export default __exports__